import React from 'react';

import { useNavigateToCheckout } from '~/views/settings/subscription/hooks/use-navigate-to-checkout/useNavigateToCheckout';

import { AlertTrialEnds } from './components/alert-trial-ends/AlertTrialEnds';
import * as S from './NotificationAlerts.styles';

export const NotificationAlerts = () => {
  const upgradeToPro = useNavigateToCheckout();

  return (
    <S.NotificationAlertsRoot data-testid="notification-alerts">
      <AlertTrialEnds upgradeToPro={upgradeToPro} />
    </S.NotificationAlertsRoot>
  );
};
